import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Page } from "../../helbest";
import { ProductItem } from "../components";
import Drawer from "../components/Drawer/Drawer";
import ModalLocation from "../components/ModalLocation/ModalLocation";
import CategoryBar from "../components/Home/CategoryBar/CategoryBar";
import useProducts from "../components/Home/CategoryBar/useProducts";
import Loading from "../components/Loading/Loading";

const Category = () => {
  const [show_modal, set_show_modal] = useState(false);
  const [show_footer, set_show_footer] = useState(true);
  const [searchParams] = useSearchParams();
  const { products, refetch, loading } = useProducts(
    Object.fromEntries(searchParams)
  );
  
  useEffect(() => {
    refetch();
  }, [searchParams.toString()]);

  return (
    <React.Fragment>
      <Page
        hasHeader
        className="page-category"
        customPageClassName="grow"
        showFooter={show_footer}
        title={null}
        drawer={<Drawer />}
        cart
        logo
      >
        <CategoryBar filter />
        {loading ? (
          <div className="flex center-content grow">
            <Loading />
          </div>
        ) : (
          <div className="page-category-product-container">
            {products?.map((data) => {
              return (
                <div
                  key={data.id}
                  style={{
                    ...(data.quantityAvailable === 0 && { order: "1" }),
                  }}
                  className="w-full"
                >
                  <ProductItem data={data} set_show_footer={set_show_footer} />
                </div>
              );
            })}
          </div>
        )}
      </Page>
      <ModalLocation
        visible={show_modal}
        toInvisible={() => set_show_modal(false)}
        // sliderFunction={_GET_Slider}
      />
    </React.Fragment>
  );
};

export default Category;
